/*
 * Copyright (c) 2019 - Convergence Labs, Inc.
 *
 * This file is part of the Convergence Server, which is released under
 * the terms of the GNU General Public License version 3 (GPLv3). A copy
 * of the GPLv3 should have been provided along with this file, typically
 * located in the "LICENSE" file, which is part of this source code package.
 * Alternatively, see <https://www.gnu.org/licenses/gpl-3.0.html> for the
 * full text of the GPLv3 license, if it was not provided.
 */

export class ModelSnapshotPolicy {
  constructor(public readonly snapshotsEnabled: boolean,
              public readonly triggerByVersion: boolean,
              public readonly maximumVersionInterval: number,
              public readonly limitByVersion: boolean,
              public readonly minimumVersionInterval: number,
              public readonly triggerByTime: boolean,
              public readonly maximumTimeInterval: number,
              public readonly limitByTime: boolean,
              public readonly minimumTimeInterval: number) {
    Object.freeze(this);
  }
}
